'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResulstSelect = exports.PaginationClickableContent = exports.PaginationClickableContainer = exports.PaginationContent = exports.BoundaryTitle = exports.BoundaryContent = exports.BoundaryClickableContainer = exports.PageNumberCol = exports.PageNumberUnderScore = exports.PageNumberContainer = exports.PageNumberTypography = exports.Typography = exports.MaxPerPageCol = exports.PaginationCol = exports.PaginationFooterContainer = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  height: 30px;\n'], ['\n  height: 30px;\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n'], ['\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 13px;\n  font-weight: 400;\n  text-align: center;\n'], ['\n  color: ', ';\n  font-size: 13px;\n  font-weight: 400;\n  text-align: center;\n']),
  _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  font-weight: ', ';\n'], ['\n  font-size: 11px;\n  font-weight: ', ';\n']),
  _templateObject5 = _taggedTemplateLiteral(['\n  margin: 0 5px;\n  display: flex;\n  background-color: transparent;\n  padding: 10px 15px;\n  text-align: center;\n  flex-direction: column;\n  justify-content: center;\n'], ['\n  margin: 0 5px;\n  display: flex;\n  background-color: transparent;\n  padding: 10px 15px;\n  text-align: center;\n  flex-direction: column;\n  justify-content: center;\n']),
  _templateObject6 = _taggedTemplateLiteral(['\n  height: 2px;\n  width: 15px;\n  background-color: ', ';\n'], ['\n  height: 2px;\n  width: 15px;\n  background-color: ', ';\n']),
  _templateObject7 = _taggedTemplateLiteral(['\n  cursor: pointer;\n'], ['\n  cursor: pointer;\n']),
  _templateObject8 = _taggedTemplateLiteral(['\n  cursor: ', ';\n  width: 20%;\n  display: flex;\n  justify-content: ', ';\n  visibility: ', '\n'], ['\n  cursor: ', ';\n  width: 20%;\n  display: flex;\n  justify-content: ', ';\n  visibility: ', '\n']),
  _templateObject9 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  margin-right: ', ';\n  margin-left: ', ';\n'], ['\n  font-size: 11px;\n  margin-right: ', ';\n  margin-left: ', ';\n']),
  _templateObject10 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  margin-right: ', ';\n  margin-left: ', ';\n'], ['\n  font-size: 13px;\n  margin-right: ', ';\n  margin-left: ', ';\n']),
  _templateObject11 = _taggedTemplateLiteral(['\n  width: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center \n'], ['\n  width: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center \n']),
  _templateObject12 = _taggedTemplateLiteral(['\n  cursor: ', ';\n  margin-right: ', ';\n  margin-left: ', ';\n  visibility: ', '\n'], ['\n  cursor: ', ';\n  margin-right: ', ';\n  margin-left: ', ';\n  visibility: ', '\n']),
  _templateObject13 = _taggedTemplateLiteral(['\n  font-size: 11px;\n'], ['\n  font-size: 11px;\n']),
  _templateObject14 = _taggedTemplateLiteral(['\n  background-color: transparent;\n  border: none;\n  color: ', ';\n  font-size: 14px;\n  margin-left: 10px;\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  background-color: transparent;\n  border: none;\n  color: ', ';\n  font-size: 14px;\n  margin-left: 10px;\n\n  &:focus {\n    outline: none;\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.columns');
var _wavfichacertaFichacertaSharedStyles2 = require('@bit/wavfichacerta.fichacerta.shared-styles.rows');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var PaginationFooterContainer = exports.PaginationFooterContainer = (0, _styledComponents2.default)(_wavfichacertaFichacertaSharedStyles2.StyledRow)(_templateObject);
var PaginationCol = exports.PaginationCol = (0, _styledComponents2.default)(_wavfichacertaFichacertaSharedStyles.BaseColumn).attrs({
  xl: 6,
  lg: 6,
  md: 6,
  sm: 12,
  col: 6
})(_templateObject2);
var MaxPerPageCol = exports.MaxPerPageCol = (0, _styledComponents2.default)(_wavfichacertaFichacertaSharedStyles.HalfColumn)(_templateObject2);
var Typography = exports.Typography = _styledComponents2.default.span(_templateObject3, function (props) {
  return props.theme.color_gray;
});
var PageNumberTypography = exports.PageNumberTypography = (0, _styledComponents2.default)(Typography)(_templateObject4, function (props) {
  return props.current ? 'bold' : 400;
});
var PageNumberContainer = exports.PageNumberContainer = _styledComponents2.default.div(_templateObject5);
var PageNumberUnderScore = exports.PageNumberUnderScore = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.theme.color_gray;
});
var PageNumberCol = exports.PageNumberCol = (0, _styledComponents2.default)(_wavfichacertaFichacertaSharedStyles.BaseColumn).attrs({
  xl: 'auto',
  lg: 'auto',
  md: 'auto',
  sm: 'auto',
  col: 'auto'
})(_templateObject7);
var BoundaryClickableContainer = exports.BoundaryClickableContainer = _styledComponents2.default.div(_templateObject8, function (props) {
  return props.visible ? 'pointer' : 'default';
}, function (props) {
  return props.justify;
}, function (props) {
  return props.visible ? 'show' : 'hidden';
});
var BoundaryContent = exports.BoundaryContent = _styledComponents2.default.span(_templateObject9, function (props) {
  return props.margin.right || 0;
}, function (props) {
  return props.margin.left || 0;
});
var BoundaryTitle = exports.BoundaryTitle = _styledComponents2.default.span(_templateObject10, function (props) {
  return props.margin.right || 0;
}, function (props) {
  return props.margin.left || 0;
});
var PaginationContent = exports.PaginationContent = _styledComponents2.default.div(_templateObject11);
var PaginationClickableContainer = exports.PaginationClickableContainer = _styledComponents2.default.div(_templateObject12, function (props) {
  return props.visible ? 'pointer' : 'default';
}, function (props) {
  return props.margin.right || 0;
}, function (props) {
  return props.margin.left || 0;
}, function (props) {
  return props.visible ? 'show' : 'hidden';
});
var PaginationClickableContent = exports.PaginationClickableContent = _styledComponents2.default.span(_templateObject13);
var ResulstSelect = exports.ResulstSelect = _styledComponents2.default.select(_templateObject14, function (props) {
  return props.theme.color_gray;
});